export enum AdminCommissionExchangeType {
  user = "for_user",
  all = "for_all",
}
